import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

async function todoListSendActionRequest(id, action_type, body, skipReload = false) {
  try {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    const response = await axios.post(`/to_do_lists/${id}/${action_type}.json`, body, {
      headers: {
        "X-CSRF-Token": csrfToken
      }
    });

    if ((response.status >= 200 && response.status < 300) || response.status === 302) {
      if (!skipReload) {
        window.location.reload();
      }
    }

    return response;
  } catch (err) {
    toastr.error("Something went wrong");
    return { error: true };
  }
}

export async function todoListMarkInCompleteTask(
  id,
  inCompletedToDoDate,
  hourlyRecurrenceTime,
  userInitial,
  reason,
  seen
) {
  await todoListSendActionRequest(id, "incomplete", {
    incompleted_to_do_date: inCompletedToDoDate,
    hourly_recurrence_time: hourlyRecurrenceTime,
    user_initial: userInitial,
    reason: reason,
    seen: seen
  });
}

export async function todoListMarkCompleteTask(
  id,
  toDoListDate,
  hourlyRecurrenceTime,
  userInitial,
  reason,
  seen
) {
  await todoListSendActionRequest(id, "completed", {
    completed_to_date: toDoListDate,
    hourly_recurrence_time: hourlyRecurrenceTime,
    user_initial: userInitial,
    seen: seen,
    ...(reason ? { completed_future_task_reason: reason } : {})
  });
}

export async function todoListSkipTask(
  id,
  toDoListDate,
  taskToDoListTime,
  seen,
  skipOccurrenceOption,
  userInitial,
  reason
) {
  await todoListSendActionRequest(id, "skip_occurrence", {
    id: id,
    task_completed_to_do_date: toDoListDate,
    task_to_do_list_time: taskToDoListTime,
    initial: userInitial,
    seen: seen,
    skip_occurrence_option: skipOccurrenceOption,
    ...(reason ? { reason: reason } : {})
  });
}

export async function todoListInProgress(id) {
  await todoListSendActionRequest(id, "in_progress", {
    id: id
  });
}

const intToShiftString = (rawShiftValue) => {
  if (typeof rawShiftValue === "string") {
    if (rawShiftValue.toLowerCase().includes("shift:")) {
      return rawShiftValue;
    }
    const parsed = parseInt(rawShiftValue, 10);
    rawShiftValue = Number.isNaN(parsed) ? undefined : parsed;
  }

  if (rawShiftValue === 1) return "Shift: 1st";
  if (rawShiftValue === 2) return "Shift: 2nd";
  if (rawShiftValue === 3) return "Shift: 3rd";
};

export async function todoListRescheduleTask(
  id,
  current_date,
  date_to_reschedule_to,
  shift_num,
  reason,
  initials,
  seen,
  keepOriginalTime,
  customTime = null,
  keepMatching = false
) {
  try {
    const res = await todoListSendActionRequest(
      id,
      "reschedule_to_do_list",
      {
        id: id,
        current_date: current_date,
        date_to_reschedule_to: date_to_reschedule_to,
        shift_num: intToShiftString(shift_num),
        reason: reason,
        initials: initials,
        seen: seen,
        keep_original_time: keepOriginalTime,
        custom_time: customTime,
        keep_matching: keepMatching ? "true" : "false"
      },
      true
    );
    if (res.error) throw res.error;
    return res;
  } catch (err) {
    return { error: err };
  }
}

export const isToDoListInFuture = (toDoListTime, todoListDate) => {
  if (!toDoListTime) return false;
  const todoListTime = new Date(toDoListTime);
  const toDoListJSDateAndTime = new Date(
    todoListDate + " " + todoListTime.getHours() + ":" + todoListTime.getMinutes() + ":00"
  );
  return toDoListJSDateAndTime <= new Date();
};
